import {
  SdmMatchConfig,
  SdmOffer,
  SiteMarketplaceGraphs,
} from "../models/site";
import axiosConfig from "./axiosConfig";

const postSiteMarketplaceGraphs = async (
  authToken: string,
  siteId: string,
  extraSdmBuyOffer?: SdmOffer | SdmMatchConfig,
  userOrgId?: string
): Promise<SiteMarketplaceGraphs> => {
  const urlArgs: string[] = [];
  if (userOrgId) {
    urlArgs.push(`userOrgId=${userOrgId}`);
  }
  const { data } = await axiosConfig.post(
    `/site/${siteId}/marketplace_graphs${urlArgs.length ? `?${urlArgs.join("&")}` : ""}`,
    extraSdmBuyOffer,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postSiteMarketplaceGraphs;
